import { useState, useRef } from "react";
import { API } from "../lib/api";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";
import { Upload, Loader2, CheckCircle2, FileSpreadsheet } from "lucide-react";
import { toast } from "sonner";

export default function ImportExcelDialog({ onDone }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const fileRef = useRef(null);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    setResult(null);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const t = localStorage.getItem("crm_token");
      const r = await fetch(`${API}/import/gare`, { method: "POST", headers: { Authorization: `Bearer ${t}` }, body: fd });
      const data = await r.json();
      if (!r.ok) throw new Error(data.detail || "err");
      setResult(data);
      toast.success(`${data.imported} gare importate`);
      onDone && onDone();
    } catch (e) { toast.error(e.message || "Errore import"); }
    finally { setLoading(false); if (fileRef.current) fileRef.current.value = ""; }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { setOpen(v); if (!v) setResult(null); }}>
      <DialogTrigger asChild>
        <Button variant="outline" data-testid="import-excel-btn"><FileSpreadsheet className="h-4 w-4 mr-1.5" /> Import Excel</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader><DialogTitle>Importa gare da Excel</DialogTitle></DialogHeader>
        <p className="text-sm text-neutral-600">
          Carica un file .xlsx con almeno le colonne <span className="font-mono">Gara</span>, <span className="font-mono">Ente</span>, <span className="font-mono">Importo</span>, <span className="font-mono">Scadenza</span>. Il sistema crea automaticamente i clienti mancanti.
        </p>
        <input ref={fileRef} type="file" accept=".xlsx,.xlsm" onChange={handleFile} className="hidden" data-testid="import-file-input" />
        <button
          onClick={() => fileRef.current?.click()}
          disabled={loading}
          data-testid="import-drop-btn"
          className="border-2 border-dashed border-neutral-300 hover:border-[color:var(--brand-primary)] p-10 text-center bg-neutral-50">
          {loading ? (
            <div className="flex items-center justify-center gap-2 text-neutral-700"><Loader2 className="h-5 w-5 animate-spin" /> Elaborazione...</div>
          ) : (
            <>
              <Upload className="h-8 w-8 mx-auto text-neutral-400" />
              <div className="mono-label mt-3">Clicca per selezionare il file .xlsx</div>
            </>
          )}
        </button>
        {result && (
          <div className="border border-emerald-200 bg-emerald-50 p-4 flex items-start gap-2">
            <CheckCircle2 className="h-5 w-5 text-emerald-700 flex-shrink-0" />
            <div className="text-sm text-emerald-900">
              <div className="font-semibold">Importate {result.imported} gare</div>
              {result.skipped > 0 && <div>{result.skipped} già esistenti (saltate)</div>}
              {result.errors?.length > 0 && <div className="text-red-700 mt-1">{result.errors.length} errori</div>}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
